import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@environments/environment';
import { Alert } from '@app/_models';
import { Observable } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class idiomaService {
    alertas: Alert[];
    public idiomaDefecto;
    public idiomas = [];
    constructor(
        private http: HttpClient
    ) {
        this.idiomas.push({
            nombre : 'Español',
            value : 'es'
        },{
            nombre : 'English',
            value : 'en'
        }) 
    }

    postIdioma(idioma) {
        this.idiomaDefecto = idioma;
        localStorage.setItem('language',idioma);
    }

    getIdioma(){
        return this.idiomaDefecto;
    }



}
